var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFavoriteSmallSelected({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3089 10.7827C17.2402 10.5873 17.0607 10.45 16.8509 10.4324L13.8203 9.99837L12.4622 7.29497C12.3732 7.11458 12.187 7 11.9828 7C11.7787 7 11.5925 7.11458 11.5035 7.29497L10.1453 9.99314L7.11482 10.4324C6.91372 10.4604 6.74639 10.5984 6.68341 10.7879C6.62582 10.973 6.67705 11.1742 6.81656 11.3108L9.01622 13.4024L8.48362 16.3725C8.44479 16.5727 8.52794 16.7768 8.69666 16.8954C8.86093 17.0107 9.07749 17.0249 9.2559 16.932L11.9828 15.5359L14.6991 16.9372C14.7739 16.9786 14.8583 17.0003 14.9441 17C15.057 17.0004 15.167 16.9656 15.2584 16.9006C15.4271 16.782 15.5102 16.5779 15.4714 16.3777L14.9388 13.4077L17.1385 11.3161C17.2954 11.1855 17.3618 10.9779 17.3089 10.7827Z",
    fill: "#FBC700"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteSmallSelected);
export default ForwardRef;